export default __webpack_public_path__ + "static/media/seth.63f5d603.svg";